module.exports = __webpack_public_path__ + "img/img_home01.e3e4ee1b.jpg";